module.exports = "//static.hsappstatic.net/LoginUI/static-1.14093/img/google-logo.png"